// Insert a row into the notes collection. Reused by the header's "+ New
// note"/import actions, chat's "save as note" and meet's applySuggestion so
// the same code path serves every producer.
//
// Returns the new row's id on success, null on failure.
import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'
import { _docContent, _joinBodyText, _firstImage } from './parseBody.js'

export const createNote = async function ({
  title = 'Untitled note',
  content = '',
  tags = [],
  source = 'member',
  privacy,
  folderPath
} = {}) {
  const root = this.state.root
  const row = {
    title,
    body: content,
    author: root.currentUserEmail || 'Unknown',
    source,
    tags,
    ...(privacy ? { privacy } : {}),
    ...(folderPath ? { folderPath } : {})
  }
  let data
  try {
    const result = await getSDK().execute('docs.notes', 'create', row)
    data = result?.data || result
  } catch (err) {
    console.error('[createNote] insert failed', err)
    return null
  }
  const id = data?.docId || data?._id || data?.id
  if (!id) return null
  // Optimistic state merge so the new note appears immediately — in BOTH
  // stores: `documents` feeds the unified /notes grid, `notes` feeds the
  // chat/AI note pickers.
  const parsed = _docContent(content)
  const nowDay = new Date().toISOString().slice(0, 10)
  const docRow = {
    id,
    title,
    folder: folderPath || '',
    type: 'note',
    source,
    privacy: privacy || 'team',
    tags,
    author: row.author,
    summary: '',
    _bodyText: _joinBodyText(parsed),
    _cover: _firstImage(parsed),
    content: parsed,
    updatedAt: new Date().toISOString()
  }
  root.update({
    documents: [...(root.documents || []), docRow],
    notes: [
      ...(root.notes || []),
      {
        id,
        title,
        content: parsed,
        author: row.author,
        source,
        tags,
        createdAt: nowDay
      }
    ],
    selectedNoteId: id
  })
  this.call('forgetDocLists')
  return id
}
